import { render } from "./AudienceArchive.vue?vue&type=template&id=4bf08283"
import script from "./AudienceArchive.vue?vue&type=script&setup=true&lang=js"
export * from "./AudienceArchive.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/audience/AudienceArchive.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4bf08283"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4bf08283', __exports__)) {
    api.reload('4bf08283', __exports__)
  }
  
  module.hot.accept("./AudienceArchive.vue?vue&type=template&id=4bf08283", () => {
    api.rerender('4bf08283', render)
  })

}


export default __exports__